// Generated by ReScript, PLEASE EDIT WITH CARE


var default_meta_title = "Pickup drop parcels, courier delivery service from Porter";

var default_meta_desc = "Send packages and get it delivered right at your doorstep. On-demand, hyperlocal online delivery service anywhere in you city. Get a 2 wheeler in 15 mins.";

var ga_page_landing = "fe_2wpage_land";

var timeout_value = 0;

var order_interest_website_source = "website";

var order_interest_desktop_source = "Desktop Website";

var order_interest_mobile_source = "Mobile Website";

var ga_action_inter_city_web = "Intercity Opp(website)";

var pnm_ga_bounds_validate = "Form/Bounds-validate<Navigate>";

var pnm_ga_event_parameter_label = "PNM Event Parameter";

var pnm_ga_marketing_campaign_event = "Proceed Button Succeed";

var pnm_ga_marketing_campaign_event_home = "Proceed Button Succeed - Home";

var pnm_ga_marketing_campaign_event_v2 = "Proceed Button Succeed V2";

var pnm_ga_base_form_submit = "Submitted Basic Details";

var pnm_ga_estimate_sticky = "Request Callback Sticky Clicked";

var pnm_ga_base_form_submit_inter_city = "Proceed button Succeed_inter";

var pnm_ga_base_form_submit_intra_city = "Proceed button Succeed_intra";

var default_house_type = "1BHK";

var scf_source_desktop_website = "desktop_website";

var default_network_error = "Something went wrong! Please try submitting again.";

var pickup_location_label = "Pickup Location";

var pickup_location_placeholder = "Sending from";

var drop_location_label = "Drop Location";

var drop_location_placeholder = "Sending to";

var phone_number_label = "Phone Number";

var phone_number_placeholder = "Enter Contact Details";

var shifting_date_label = "Shifting Date";

var house_size_label = "House Size";

var shifting_date_placeholder = "Enter Date";

var request_callback_title = "Get an estimate";

var request_callback_title_v2 = "Check Price";

var confirmation_modal_title = "We have received your request!";

var confirmation_modal_subtitle = "Our team is working on your request and will get back to you!";

var no_result_found_text = "No result found";

var enter_valid_address_text = "Please enter the valid address";

var no_mobile_found_text = "Enter your mobile number";

var enter_valid_mobile_text = "Enter valid mobile number";

var enter_valid_date_text = "Please enter a valid date";

var invalid_date_text = "Please do not select a past date";

var ssr_pilliar_keyword = "default";

var something_went_wrong = "Something went wrong";

var failed_to_process_your_request = "Failed to process your request";

var close = "Close";

var inMeter = "in_meters";

var defaultParkingDistance = 50;

var noLift = "no_lift";

var errorIconUrl = "https://dom-content-vault-prod-cdn-assets.porter.in/payment_failure_57b845ed2a/payment_failure_57b845ed2a.svg";

var errorIconAlt = "Error icon";

var pnm_cta_exp_ga_event_parameter_label = "PNM Form CTA - ";

var courier_external_id = "cr_ext_id";

var pnm_ga_submit_event = "Request Callback";

var calenderIcon = "https://dom-content-vault-prod-cdn-assets.porter.in/Calendar_Icon_6365271904/Calendar_Icon_6365271904.svg";

var phoneIcon = "https://dom-content-vault-prod-cdn-assets.porter.in/phone_b195e50477.svg";

var houseSizeIcon = "https://dom-content-vault-prod-cdn-assets.porter.in/home_36d5b076d1/home_36d5b076d1.svg";

var accordianIcon = "https://dom-content-vault-prod-cdn-assets.porter.in/chevron_down_default_65d32e52ce/chevron_down_default_65d32e52ce.svg";

var calenderIconAlt = "Calendar Icon";

var phoneIconAlt = "Phone Icon";

var houseSizeIconAlt = "House Size Icon";

var accordianIconAlt = "Accordian Icon";

var houseSizeList = {
  hd: /* OneRk */3,
  tl: {
    hd: /* OneBhk */0,
    tl: {
      hd: /* TwoBhk */1,
      tl: {
        hd: /* ThreeBhk */2,
        tl: /* [] */0
      }
    }
  }
};

var houseSizeEvent = "proceed_button_succeed_";

var noHouseSizeEvent = "none";

var houseSizeNotShownEvent = "not_shown";

var houseSizePlaceholder = "Select House Size";

var houseSizeErrorText = "Please select the house size";

var oneBhkString = "1 BHK";

var oneRKString = "1 RK";

var twoBhkString = "2 BHK";

var threeBhkString = "3 BHK and above+";

var knowMore = "Know More";

var pnmEntryEvent = "micrositeimage_clicked";

var pmnCampaignImage = "https://dom-website-prod-cdn-web.porter.in/public/images/packers-and-movers/pnm_campaign.png";

var pmnCampaignKnowMoreLink = "/packers-and-movers/safety-guarantee";

var booking_end_time = 18.0;

var booking_max_date = 50.0;

var date_format = "DD/MM/YYYY";

var dropdownListTimeDelay = 200;

export {
  default_meta_title ,
  default_meta_desc ,
  ga_page_landing ,
  timeout_value ,
  order_interest_website_source ,
  order_interest_desktop_source ,
  order_interest_mobile_source ,
  ga_action_inter_city_web ,
  pnm_ga_bounds_validate ,
  pnm_ga_event_parameter_label ,
  pnm_ga_marketing_campaign_event ,
  pnm_ga_marketing_campaign_event_home ,
  pnm_ga_marketing_campaign_event_v2 ,
  pnm_ga_base_form_submit ,
  pnm_ga_estimate_sticky ,
  pnm_ga_base_form_submit_inter_city ,
  pnm_ga_base_form_submit_intra_city ,
  default_house_type ,
  scf_source_desktop_website ,
  default_network_error ,
  pickup_location_label ,
  pickup_location_placeholder ,
  drop_location_label ,
  drop_location_placeholder ,
  phone_number_label ,
  phone_number_placeholder ,
  shifting_date_label ,
  house_size_label ,
  shifting_date_placeholder ,
  request_callback_title ,
  request_callback_title_v2 ,
  confirmation_modal_title ,
  confirmation_modal_subtitle ,
  no_result_found_text ,
  enter_valid_address_text ,
  no_mobile_found_text ,
  enter_valid_mobile_text ,
  enter_valid_date_text ,
  invalid_date_text ,
  ssr_pilliar_keyword ,
  something_went_wrong ,
  failed_to_process_your_request ,
  close ,
  inMeter ,
  defaultParkingDistance ,
  noLift ,
  errorIconUrl ,
  errorIconAlt ,
  pnm_cta_exp_ga_event_parameter_label ,
  courier_external_id ,
  pnm_ga_submit_event ,
  calenderIcon ,
  phoneIcon ,
  houseSizeIcon ,
  accordianIcon ,
  calenderIconAlt ,
  phoneIconAlt ,
  houseSizeIconAlt ,
  accordianIconAlt ,
  houseSizeList ,
  houseSizeEvent ,
  noHouseSizeEvent ,
  houseSizeNotShownEvent ,
  houseSizePlaceholder ,
  houseSizeErrorText ,
  oneBhkString ,
  oneRKString ,
  twoBhkString ,
  threeBhkString ,
  knowMore ,
  pnmEntryEvent ,
  pmnCampaignImage ,
  pmnCampaignKnowMoreLink ,
  booking_end_time ,
  booking_max_date ,
  date_format ,
  dropdownListTimeDelay ,
}
/* No side effect */
